export default __webpack_public_path__ + "static/media/charles_on.b06cf02c.png";